"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAnalyticsEventBatchDto = instanceOfAnalyticsEventBatchDto;
exports.AnalyticsEventBatchDtoFromJSON = AnalyticsEventBatchDtoFromJSON;
exports.AnalyticsEventBatchDtoFromJSONTyped = AnalyticsEventBatchDtoFromJSONTyped;
exports.AnalyticsEventBatchDtoToJSON = AnalyticsEventBatchDtoToJSON;
exports.AnalyticsEventBatchDtoToJSONTyped = AnalyticsEventBatchDtoToJSONTyped;
const AnalyticsEventDto_1 = require("./AnalyticsEventDto");
/**
 * Check if a given object implements the AnalyticsEventBatchDto interface.
 */
function instanceOfAnalyticsEventBatchDto(value) {
    if (!('events' in value) || value['events'] === undefined)
        return false;
    return true;
}
function AnalyticsEventBatchDtoFromJSON(json) {
    return AnalyticsEventBatchDtoFromJSONTyped(json, false);
}
function AnalyticsEventBatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'events': (json['events'].map(AnalyticsEventDto_1.AnalyticsEventDtoFromJSON)),
    };
}
function AnalyticsEventBatchDtoToJSON(json) {
    return AnalyticsEventBatchDtoToJSONTyped(json, false);
}
function AnalyticsEventBatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'events': (value['events'].map(AnalyticsEventDto_1.AnalyticsEventDtoToJSON)),
    };
}
//# sourceMappingURL=AnalyticsEventBatchDto.js.map